module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Select Param set for " + _vm._s(_vm.is_amp ? 'AMP' : 'DISPLAY') + " ad units")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "display": "inline-block",
      "width": "80%",
      "margin": "0 0 10px 10px"
    },
    attrs: {
      "data-vv-delay": "1000",
      "name": "searchString",
      "type": "text",
      "placeholder": "search HB Unit by HB Unit tag (type and enter)"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterHbAdUnit()
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "clearSearch",
      "placement": "top"
    }
  }, [_c('el-button', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "danger",
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.clearSearch()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Select Dimensions",
      "name": "Dimensions"
    },
    on: {
      "change": function($event) {
        return _vm.filterDimension()
      }
    },
    model: {
      value: (_vm.selectedDimensions),
      callback: function($$v) {
        _vm.selectedDimensions = $$v
      },
      expression: "selectedDimensions"
    }
  }, _vm._l((_vm.allDimensionsSearch), function(dimension, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": ((dimension.width) + "X" + (dimension.height)),
        "value": dimension.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-input', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "data-vv-delay": "1000",
      "name": "selectedNetworkCode",
      "type": "text",
      "placeholder": "Search Parent Network Code"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterHbAdUnit()
      }
    },
    model: {
      value: (_vm.selectedNetworkCode),
      callback: function($$v) {
        _vm.selectedNetworkCode = $$v
      },
      expression: "selectedNetworkCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-input', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "data-vv-delay": "1000",
      "name": "selectedChildDfpNetworkCode",
      "type": "text",
      "placeholder": "Search Child Network Code"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterHbAdUnit()
      }
    },
    model: {
      value: (_vm.selectedChildDfpNetworkCode),
      callback: function($$v) {
        _vm.selectedChildDfpNetworkCode = $$v
      },
      expression: "selectedChildDfpNetworkCode"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-checkbox', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding-left": "10px",
      "width": "100%",
      "padding-top": "8px"
    },
    model: {
      value: (_vm.searchNetworkOverride),
      callback: function($$v) {
        _vm.searchNetworkOverride = $$v
      },
      expression: "searchNetworkOverride"
    }
  }, [_vm._v("Search Network Override?")])], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "element-promt",
    attrs: {
      "title": "Meta Tags",
      "visible": _vm.pubInsdialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.pubInsdialogVisible = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 10
    },
    model: {
      value: (_vm.pubInstructions),
      callback: function($$v) {
        _vm.pubInstructions = $$v
      },
      expression: "pubInstructions"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pubInsdialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.pubInsdialogVisible = false
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_amp),
      expression: "is_amp"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.pubInstructions),
      expression: "pubInstructions",
      arg: "copy"
    }],
    staticClass: "el-button el-button--info pull-right",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.pubInsdialogVisible = true
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-copy fa-w-14",
    staticStyle: {
      "font-size": "48px"
    },
    attrs: {
      "aria-hidden": "true",
      "width": "16px",
      "height": "16px",
      "data-prefix": "fal",
      "data-icon": "copy",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"
    }
  })]), _vm._v("  Copy Publisher Instructions\n                    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('router-link', {
    staticClass: "el-button el-button--info pull-right",
    attrs: {
      "to": _vm.is_amp ?
        ("/admin/publisher/" + _vm.pubUid + "/domain/" + _vm.domId + "/create-hb-tag-amp/") :
        ("/admin/publisher/" + _vm.pubUid + "/domain/" + _vm.domId + "/create-hb-tag/")
    }
  }, [_c('i', {
    staticClass: "el-icon-plus el-icon-left"
  }), _vm._v("\n                            Create " + _vm._s(_vm.is_amp ? "AMP" : "display") + " HB tag\n                        ")]), _vm._v(" "), (_vm.domainMcmEnabled) ? _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.bulkmigrateEnabled = !_vm.bulkmigrateEnabled
      }
    }
  }, [_vm._v("Bulk Migrate")]) : _vm._e()], 1), _vm._v(" "), (_vm.domainMcmEnabled && _vm.bulkmigrateEnabled) ? _c('div', {}, [_c('h4', {
    staticClass: "box-title"
  }, [_vm._v("Bulk Migration")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "80%",
      "margin": "0px 0px 10px 10px"
    }
  }, [_c('h5', [_vm._v("Is MCM Enabled?")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.mcm_enabled),
      callback: function($$v) {
        _vm.mcm_enabled = $$v
      },
      expression: "mcm_enabled"
    }
  }, [_vm._v("Is sticky Unit?")])], 1), _vm._v(" "), (_vm.mcm_enabled && _vm.domainMcmEnabled) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0px 0px 8px -6px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Select MCM Delegation Type:")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select MCM Delegation Type"
    },
    on: {
      "change": _vm.filterNetworkList
    },
    model: {
      value: (_vm.account_type),
      callback: function($$v) {
        _vm.account_type = $$v
      },
      expression: "account_type"
    }
  }, _vm._l((_vm.mcmAccountType), function(mcm_account_type, id) {
    return _c('el-option', {
      key: id,
      attrs: {
        "data-id": id,
        "label": mcm_account_type.account_type.replaceAll('_', ' '),
        "value": mcm_account_type.account_type
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Select Child DFP Network")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "disabled": _vm.account_type == null,
      "filterable": "",
      "placeholder": "Select Child DFP Network"
    },
    model: {
      value: (_vm.child_dfp_network),
      callback: function($$v) {
        _vm.child_dfp_network = $$v
      },
      expression: "child_dfp_network"
    }
  }, _vm._l((_vm.filteredAccountList), function(network) {
    return _c('el-option', {
      key: network.id,
      attrs: {
        "label": ("" + (network.child_network_code + ' : ' + network.name)),
        "value": network.child_network_code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Add DFP Parent Adunit Id")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": _vm.account_type == null && _vm.child_dfp_network == null,
      "placeholder": "Add DFP Parent Adunit Id"
    },
    model: {
      value: (_vm.dfp_parent_ad_unit_id),
      callback: function($$v) {
        _vm.dfp_parent_ad_unit_id = $$v
      },
      expression: "dfp_parent_ad_unit_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Add DFP Parent Adunit Path")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": _vm.account_type == null || _vm.child_dfp_network == null || _vm.dfp_parent_ad_unit_id == 0,
      "placeholder": "Add DFP Parent Adunit Path"
    },
    model: {
      value: (_vm.dfp_parent_ad_unit_path),
      callback: function($$v) {
        _vm.dfp_parent_ad_unit_path = $$v
      },
      expression: "dfp_parent_ad_unit_path"
    }
  })], 1), _vm._v(" "), (_vm.account_type != null) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "success",
      "disabled": _vm.dfp_parent_ad_unit_path == null || _vm.dfp_parent_ad_unit_path == ''
    },
    on: {
      "click": function($event) {
        return _vm.finalList(true)
      }
    }
  }, [_vm._v("\n                                    Migrate all\n                                ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "success",
      "disabled": _vm.dfp_parent_ad_unit_path == null || _vm.dfp_parent_ad_unit_path == ''
    },
    on: {
      "click": function($event) {
        return _vm.finalList(false)
      }
    }
  }, [_vm._v("\n                                    Migrate selected\n                                ")])], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "padding-top": "30px"
    }
  }, [(_vm.hb_tags.length == 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('h5', [_vm._v("No " + _vm._s(_vm.is_amp ? 'AMP' : 'display') + " HB tags. Create a tag by clicking create HB tag")])]) : _vm._e(), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.hb_tags), function(hb_tag) {
    return _c('el-collapse-item', {
      staticClass: "collapse--item",
      class: {
        recentlyClosed: _vm.recentlyClosed == hb_tag.id,
          opened: _vm.activeNames == hb_tag.id,
      },
      attrs: {
        "title": hb_tag.id + '',
        "name": hb_tag.id
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "36%",
        "float": "left",
        "position": "relative"
      }
    }, [(_vm.domainMcmEnabled && _vm.bulkmigrateEnabled) ? _c('el-checkbox-group', {
      staticClass: "hb-tag--checkbox-container",
      attrs: {
        "disabled": hb_tag.publisher_dfp_unit
      },
      on: {
        "change": _vm.handleCheckedHbTagsChange
      },
      model: {
        value: (_vm.checkedHbTags),
        callback: function($$v) {
          _vm.checkedHbTags = $$v
        },
        expression: "checkedHbTags"
      }
    }, [_c('el-checkbox', {
      key: hb_tag.id,
      attrs: {
        "label": hb_tag.id
      }
    }, [_c('label', {
      staticStyle: {
        "font-weight": "900",
        "white-space": "nowrap",
        "text-overflow": "ellipsis"
      },
      attrs: {
        "title": _vm.getAdunitPath(hb_tag)
      }
    }, [_vm._v(_vm._s(_vm.getAdunitPath(hb_tag)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "else",
        rawName: "v-else:title",
        value: (_vm.getAdunitPath(hb_tag)),
        expression: "getAdunitPath(hb_tag)",
        arg: "title"
      }],
      staticStyle: {
        "font-weight": "900",
        "white-space": "nowrap",
        "text-overflow": "ellipsis",
        "overflow": "hidden"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\n                                                " + _vm._s(_vm.getAdunitPath(hb_tag)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\n                                            ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "hbtag--dimension",
      staticStyle: {
        "width": "30%",
        "float": "left",
        "position": "relative"
      }
    }, [_c('h5', {
      staticStyle: {
        "/*padding": "20px 0px"
      }
    }, _vm._l((_vm.getDimension(hb_tag.dimensions)), function(dim) {
      return _c('span', {
        staticStyle: {
          "width": "100%",
          "position": "relative",
          "background-color": "aquamarine",
          "padding": "3px",
          "border-radius": "10px",
          "margin-right": "10px"
        }
      }, [_vm._v("\n                                                    " + _vm._s(dim) + "\n                                                    "), (
        _vm.bidderParamsForm2.formData[hb_tag.id][dim]['param_set'] !=
        undefined
      ) ? _c('i', {
        staticClass: "el-icon-success",
        staticStyle: {
          "/*position": "absolute",
          "left": "0px",
          "right": "0px",
          "text-align": "center",
          "top": "-12px"
        }
      }) : _vm._e()])
    }), 0)]), _vm._v(" "), _c('div', {
      class: _vm.is_amp ? 'hb-amp--container' : '',
      staticStyle: {
        "width": "30%",
        "float": "left",
        "position": "relative",
        "display": "flex"
      }
    }, [(_vm.is_amp) ? _c('el-button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.copyAmpTag(hb_tag)),
        expression: "copyAmpTag(hb_tag)",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.ampTagCopied),
        expression: "ampTagCopied",
        arg: "success"
      }],
      staticClass: "el-button el-button--info pull-right",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('i', {
      staticClass: "el-icon"
    }), _vm._v("\n                                                Copy AMP tag\n                                            ")]) : _vm._e(), _vm._v(" "), (_vm.is_amp) ? _c('el-button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.copyTagId(hb_tag)),
        expression: "copyTagId(hb_tag)",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.tagIdCopied),
        expression: "tagIdCopied",
        arg: "success"
      }],
      staticClass: "el-button el-button--info pull-right",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('i', {
      staticClass: "el-icon"
    }), _vm._v("\n                                                Copy Tag ID\n                                            ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "el-button el-button--info pull-right modify--btn",
      attrs: {
        "to": {
          path: _vm.is_amp ?
            ("/admin/publisher/" + _vm.pubUid + "/domain/" + _vm.domId + "/modify-hb-tag-amp/" + (hb_tag.id) + "/?page=" + _vm.currentPage) :
            ("/admin/publisher/" + _vm.pubUid + "/domain/" + _vm.domId + "/modify-hb-tag/" + (hb_tag.id) + "/?page=" + _vm.currentPage),
        }
      }
    }, [_c('i', {
      staticClass: "el-icon"
    }), _vm._v("\n                                                Modify Tag\n                                            ")]), _vm._v(" "), _c('router-link', {
      staticClass: "el-button el-button--info modify--btn",
      attrs: {
        "to": {
          path: _vm.is_amp ?
            ("/admin/publisher/" + _vm.pubUid + "/domain/" + _vm.domId + "/create-hb-tag-amp/?hb_id=" + (hb_tag.id) + "&page=" + _vm.currentPage) :
            ("/admin/publisher/" + _vm.pubUid + "/domain/" + _vm.domId + "/create-hb-tag/?hb_id=" + (hb_tag.id) + "&page=" + _vm.currentPage),
        }
      }
    }, [_c('i', {
      staticClass: "el-icon"
    }), _vm._v("\n                                                Duplicate Tag\n                                            ")])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "display": "inline-block"
      }
    }, [_c('el-dropdown', {
      staticClass: "see-usage",
      staticStyle: {
        "display": "inline"
      },
      attrs: {
        "trigger": "click"
      },
      on: {
        "command": _vm.OpenHbAdUnitsUsage
      }
    }, [_c('span', {
      staticClass: "el-dropdown-link"
    }, [_vm._v("\n                                        See usage in bucket"), _c('i', {
      staticClass: "el-icon-arrow-down el-icon--right"
    })]), _vm._v(" "), _c('el-dropdown-menu', {
      attrs: {
        "slot": "dropdown"
      },
      slot: "dropdown"
    }, _vm._l((_vm.domain_details.buckets), function(bucket) {
      return _c('el-dropdown-item', {
        key: bucket.id,
        attrs: {
          "command": {
            name: _vm.bucket_name,
            bucket_id: bucket.id,
            hb_tag_id: hb_tag.id,
          }
        }
      }, [_c('span', [_vm._v(_vm._s(bucket.name))])])
    }), 1)], 1)], 1)])]), _vm._v(" "), _vm._l((hb_tag.dimensions), function(dim, index) {
      return _c('div', {
        staticStyle: {
          "height": "50px",
          "margin": "10px 0px"
        }
      }, [_c('el-row', {
        attrs: {
          "gutter": 20
        }
      }, [_c('el-col', {
        attrs: {
          "span": 8
        }
      }, [_c('div', {
        staticClass: "grid-content"
      }, [_c('h5', {
        staticStyle: {
          "margin": "0px",
          "line-height": "50px",
          "display": "inline-block"
        }
      }, [_vm._v("\n                                                    Select Param set for " + _vm._s(((dim.width) + "X" + (dim.height))) + "\n                                                ")])])]), _vm._v(" "), _c('el-col', {
        staticStyle: {
          "height": "50px"
        },
        attrs: {
          "span": 8
        }
      }, [_c('div', {
        staticClass: "grid-content",
        staticStyle: {
          "top": "50%",
          "position": "relative",
          "transform": "translateY(-50%)"
        }
      }, [_c('el-select', {
        staticClass: "param-set-input select-input",
        attrs: {
          "filterable": "",
          "placeholder": "Select param set"
        },
        on: {
          "change": function($event) {
            return _vm.updateHbTag(hb_tag, dim)
          }
        },
        model: {
          value: (
            _vm.bidderParamsForm2.formData[hb_tag.id][
              ((dim.width) + "X" + (dim.height))
            ]['param_set']
          ),
          callback: function($$v) {
            _vm.$set(_vm.bidderParamsForm2.formData[hb_tag.id][
              ((dim.width) + "X" + (dim.height))
            ], 'param_set', $$v)
          },
          expression: "\n                                                        bidderParamsForm2.formData[hb_tag.id][\n                                                            `${dim.width}X${dim.height}`\n                                                        ]['param_set']\n                                                    "
        }
      }, _vm._l((_vm.getParamSetsForDim(dim.id)), function(param_set) {
        return _c('el-option', {
          key: param_set.id,
          attrs: {
            "label": param_set.alias,
            "value": param_set.id
          }
        })
      }), 1)], 1)]), _vm._v(" "), _c('el-col', {
        staticStyle: {
          "height": "50px"
        },
        attrs: {
          "span": 8
        }
      }, [_c('div', {
        staticClass: "grid-content",
        staticStyle: {
          "top": "50%",
          "position": "relative",
          "transform": "translateY(-50%)"
        }
      }, [_c('div', {
        staticStyle: {
          "margin": "0px",
          "display": "inline-block"
        }
      }, [_c('el-button', {
        attrs: {
          "disabled": _vm.bidderParamsForm2.formData[hb_tag.id][
            ((dim.width) + "X" + (dim.height))
          ]['param_set'] == undefined,
          "type": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.updateHbTag(hb_tag, dim)
          }
        }
      }, [_vm._v("\n                                                        Update Tag\n                                                    ")])], 1)])])], 1)], 1)
    })], 2)
  }), 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50, 100],
      "total": _vm.total_pages,
      "layout": "sizes, prev, pager, next",
      "page-size": _vm.offset
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a0b9843!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dfp/HbTagParamsNew.vue
// module id = 673
// module chunks = 2